import { createElement, type ChangeEvent } from "react";

interface ThrottleSliderProps {
  minThrottle: number;
  maxThrottle: number;
  throttle: number;
  onThrottleChange: (throttle: number) => void;
  className: string;
}

export function ThrottleSlider({
  minThrottle,
  maxThrottle,
  throttle,
  onThrottleChange,
  className,
}: ThrottleSliderProps) {
  return createElement("input", {
    type: "range",
    "aria-label": "Throttle",
    min: minThrottle,
    max: maxThrottle,
    step: 1,
    value: throttle,
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      onThrottleChange(Number(event.target.value));
    },
    className,
  });
}
